module.exports = __webpack_public_path__ + "static/media/NCICommunity.56c18ea0.svg";